/**
 * @flow
 * @relayHash b238a730568a7d2d03d94e349bbcc3a3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type About_viewer$ref = any;
type Frame_viewer$ref = any;
type HomeGrid_viewer$ref = any;
type Imprint_viewer$ref = any;
type Menu_viewer$ref = any;
type Policies_viewer$ref = any;
type ShopItems_viewer$ref = any;
type ShoppingCart_viewer$ref = any;
export type ScreenType = {
  screenWidth?: ?number,
  screenHeight?: ?number,
  viewPortHeight?: ?number,
  viewPortWidth?: ?number,
  pixelRatio?: ?number,
};
export type AppQueryVariables = {|
  screen?: ?ScreenType,
  shopFilter?: ?string,
|};
export type AppQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: HomeGrid_viewer$ref & About_viewer$ref & ShopItems_viewer$ref & ShoppingCart_viewer$ref & Frame_viewer$ref & Menu_viewer$ref & Imprint_viewer$ref & Policies_viewer$ref
  |}
|};
export type AppQuery = {|
  variables: AppQueryVariables,
  response: AppQueryResponse,
|};
*/


/*
query AppQuery(
  $screen: ScreenType
) {
  viewer(screen: $screen) {
    ...HomeGrid_viewer
    ...About_viewer
    ...ShopItems_viewer_3ufVs2
    ...ShoppingCart_viewer
    ...Frame_viewer
    ...Menu_viewer
    ...Imprint_viewer
    ...Policies_viewer
    id
  }
}

fragment HomeGrid_viewer on Viewer {
  landingPage {
    id
    ...HomeLookBook_lookbook
    ...HomeGrid_grid
    ...LandingpageDescription_info
  }
}

fragment About_viewer on Viewer {
  categoryAbout: categoriesShop(node: "About") {
    name
    description
    id
  }
}

fragment ShopItems_viewer_3ufVs2 on Viewer {
  productByCategory(node: "all") {
    productSet {
      edges {
        node {
          ...ShopItemsProduct_product
          title
          id
        }
      }
    }
    id
  }
  productByCategories(node: "all") {
    ...ShopItemsProduct_product
    title
    id
    categories {
      edges {
        node {
          name
          id
        }
      }
    }
  }
}

fragment ShoppingCart_viewer on Viewer {
  basket {
    getTotalInclTax
    getTotalTax
    lines {
      edges {
        node {
          imageIndex
          product {
            id
            title
            upc
            attributeValues {
              edges {
                node {
                  attributeOption {
                    option
                    id
                  }
                  valueMultiOption {
                    edges {
                      node {
                        option
                        group {
                          name
                          id
                        }
                        id
                      }
                    }
                  }
                  id
                }
              }
            }
            parent {
              slug
              title
              images {
                edges {
                  node {
                    original
                    id
                  }
                }
              }
              id
            }
          }
          quantity
          priceExclTax
          priceInclTax
          priceCurrency
          id
        }
      }
    }
    id
  }
}

fragment Frame_viewer on Viewer {
  items: categoriesShop(node: "items") {
    name
    id
  }
  basket {
    getTotalItems
    id
  }
}

fragment Menu_viewer on Viewer {
  collections: landingPage {
    id
    name
    slug
  }
  items: categoriesShop(node: "items") {
    name
    id
  }
}

fragment Imprint_viewer on Viewer {
  category(node: "imprint") {
    name
    description
    id
  }
}

fragment Policies_viewer on Viewer {
  categoriesShop(node: "Policies & services") {
    name
    description
    id
  }
}

fragment ShopItemsProduct_product on ProductNode {
  title
  slug
  images {
    edges {
      node {
        original
        id
      }
    }
  }
  children {
    edges {
      node {
        productInStock {
          priceExclTax
          id
        }
        id
      }
    }
  }
}

fragment HomeLookBook_lookbook on RangeNode {
  landingpageLookbookImages {
    edges {
      node {
        original
        id
      }
    }
  }
  landingpageLookbookImagesMobile {
    edges {
      node {
        original
        id
      }
    }
  }
}

fragment HomeGrid_grid on RangeNode {
  name
  description
  includedProducts {
    edges {
      node {
        ...Product_product
        title
        landingpageImage {
          edges {
            node {
              original
              order
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment LandingpageDescription_info on RangeNode {
  name
  description
  year
  subtext
}

fragment Product_product on ProductNode {
  title
  slug
  landingpageImage {
    edges {
      node {
        original
        order
        id
      }
    }
  }
  children {
    edges {
      node {
        title
        productInStock {
          priceExclTax
          id
        }
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "screen",
    "type": "ScreenType",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "shopFilter",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "screen",
    "variableName": "screen",
    "type": "ScreenType"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "original",
  "args": null,
  "storageKey": null
},
v4 = [
  v3,
  v2
],
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "priceExclTax",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "productInStock",
  "storageKey": null,
  "args": null,
  "concreteType": "StockRecordNode",
  "plural": false,
  "selections": [
    v9,
    v2
  ]
},
v11 = [
  v5,
  v6,
  v2
],
v12 = [
  {
    "kind": "Literal",
    "name": "node",
    "value": "all",
    "type": "String"
  }
],
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "images",
  "storageKey": null,
  "args": null,
  "concreteType": "ProductImageNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "ProductImageNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "ProductImageNode",
          "plural": false,
          "selections": v4
        }
      ]
    }
  ]
},
v14 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "children",
  "storageKey": null,
  "args": null,
  "concreteType": "ProductNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "ProductNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "ProductNode",
          "plural": false,
          "selections": [
            v10,
            v2
          ]
        }
      ]
    }
  ]
},
v15 = [
  v5,
  v2
],
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "option",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "AppQuery",
  "id": null,
  "text": "query AppQuery(\n  $screen: ScreenType\n) {\n  viewer(screen: $screen) {\n    ...HomeGrid_viewer\n    ...About_viewer\n    ...ShopItems_viewer_3ufVs2\n    ...ShoppingCart_viewer\n    ...Frame_viewer\n    ...Menu_viewer\n    ...Imprint_viewer\n    ...Policies_viewer\n    id\n  }\n}\n\nfragment HomeGrid_viewer on Viewer {\n  landingPage {\n    id\n    ...HomeLookBook_lookbook\n    ...HomeGrid_grid\n    ...LandingpageDescription_info\n  }\n}\n\nfragment About_viewer on Viewer {\n  categoryAbout: categoriesShop(node: \"About\") {\n    name\n    description\n    id\n  }\n}\n\nfragment ShopItems_viewer_3ufVs2 on Viewer {\n  productByCategory(node: \"all\") {\n    productSet {\n      edges {\n        node {\n          ...ShopItemsProduct_product\n          title\n          id\n        }\n      }\n    }\n    id\n  }\n  productByCategories(node: \"all\") {\n    ...ShopItemsProduct_product\n    title\n    id\n    categories {\n      edges {\n        node {\n          name\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ShoppingCart_viewer on Viewer {\n  basket {\n    getTotalInclTax\n    getTotalTax\n    lines {\n      edges {\n        node {\n          imageIndex\n          product {\n            id\n            title\n            upc\n            attributeValues {\n              edges {\n                node {\n                  attributeOption {\n                    option\n                    id\n                  }\n                  valueMultiOption {\n                    edges {\n                      node {\n                        option\n                        group {\n                          name\n                          id\n                        }\n                        id\n                      }\n                    }\n                  }\n                  id\n                }\n              }\n            }\n            parent {\n              slug\n              title\n              images {\n                edges {\n                  node {\n                    original\n                    id\n                  }\n                }\n              }\n              id\n            }\n          }\n          quantity\n          priceExclTax\n          priceInclTax\n          priceCurrency\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment Frame_viewer on Viewer {\n  items: categoriesShop(node: \"items\") {\n    name\n    id\n  }\n  basket {\n    getTotalItems\n    id\n  }\n}\n\nfragment Menu_viewer on Viewer {\n  collections: landingPage {\n    id\n    name\n    slug\n  }\n  items: categoriesShop(node: \"items\") {\n    name\n    id\n  }\n}\n\nfragment Imprint_viewer on Viewer {\n  category(node: \"imprint\") {\n    name\n    description\n    id\n  }\n}\n\nfragment Policies_viewer on Viewer {\n  categoriesShop(node: \"Policies & services\") {\n    name\n    description\n    id\n  }\n}\n\nfragment ShopItemsProduct_product on ProductNode {\n  title\n  slug\n  images {\n    edges {\n      node {\n        original\n        id\n      }\n    }\n  }\n  children {\n    edges {\n      node {\n        productInStock {\n          priceExclTax\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment HomeLookBook_lookbook on RangeNode {\n  landingpageLookbookImages {\n    edges {\n      node {\n        original\n        id\n      }\n    }\n  }\n  landingpageLookbookImagesMobile {\n    edges {\n      node {\n        original\n        id\n      }\n    }\n  }\n}\n\nfragment HomeGrid_grid on RangeNode {\n  name\n  description\n  includedProducts {\n    edges {\n      node {\n        ...Product_product\n        title\n        landingpageImage {\n          edges {\n            node {\n              original\n              order\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment LandingpageDescription_info on RangeNode {\n  name\n  description\n  year\n  subtext\n}\n\nfragment Product_product on ProductNode {\n  title\n  slug\n  landingpageImage {\n    edges {\n      node {\n        original\n        order\n        id\n      }\n    }\n  }\n  children {\n    edges {\n      node {\n        title\n        productInStock {\n          priceExclTax\n          id\n        }\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "AppQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": v1,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "HomeGrid_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "About_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "ShopItems_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "filter",
                "variableName": "shopFilter",
                "type": null
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "ShoppingCart_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "Frame_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "Menu_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "Imprint_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "Policies_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "AppQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": v1,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "landingPage",
            "storageKey": null,
            "args": null,
            "concreteType": "RangeNode",
            "plural": true,
            "selections": [
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "landingpageLookbookImages",
                "storageKey": null,
                "args": null,
                "concreteType": "LandingpageLookbookImageNodeConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LandingpageLookbookImageNodeEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "LandingpageLookbookImageNode",
                        "plural": false,
                        "selections": v4
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "landingpageLookbookImagesMobile",
                "storageKey": null,
                "args": null,
                "concreteType": "LandingpageLookbookImageMobileNodeConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LandingpageLookbookImageMobileNodeEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "LandingpageLookbookImageMobileNode",
                        "plural": false,
                        "selections": v4
                      }
                    ]
                  }
                ]
              },
              v5,
              v6,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "includedProducts",
                "storageKey": null,
                "args": null,
                "concreteType": "ProductNodeConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ProductNodeEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ProductNode",
                        "plural": false,
                        "selections": [
                          v7,
                          v8,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "landingpageImage",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ProductLandingpageImageNodeConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ProductLandingpageImageNodeEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ProductLandingpageImageNode",
                                    "plural": false,
                                    "selections": [
                                      v3,
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "order",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      v2
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "children",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ProductNodeConnection",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "edges",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ProductNodeEdge",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ProductNode",
                                    "plural": false,
                                    "selections": [
                                      v7,
                                      v10,
                                      v2
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          v2
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "year",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "subtext",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "categoryAbout",
            "name": "categoriesShop",
            "storageKey": "categoriesShop(node:\"About\")",
            "args": [
              {
                "kind": "Literal",
                "name": "node",
                "value": "About",
                "type": "String"
              }
            ],
            "concreteType": "CategoryNode",
            "plural": true,
            "selections": v11
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "productByCategory",
            "storageKey": "productByCategory(node:\"all\")",
            "args": v12,
            "concreteType": "CategoryNode",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "productSet",
                "storageKey": null,
                "args": null,
                "concreteType": "ProductNodeConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ProductNodeEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ProductNode",
                        "plural": false,
                        "selections": [
                          v7,
                          v8,
                          v13,
                          v14,
                          v2
                        ]
                      }
                    ]
                  }
                ]
              },
              v2
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "productByCategories",
            "storageKey": "productByCategories(node:\"all\")",
            "args": v12,
            "concreteType": "ProductNode",
            "plural": true,
            "selections": [
              v7,
              v8,
              v13,
              v14,
              v2,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "categories",
                "storageKey": null,
                "args": null,
                "concreteType": "CategoryNodeConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CategoryNodeEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CategoryNode",
                        "plural": false,
                        "selections": v15
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "basket",
            "storageKey": null,
            "args": null,
            "concreteType": "BasketNode",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "getTotalInclTax",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "getTotalTax",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lines",
                "storageKey": null,
                "args": null,
                "concreteType": "LineNodeConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "LineNodeEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "LineNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "imageIndex",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "product",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ProductNode",
                            "plural": false,
                            "selections": [
                              v2,
                              v7,
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "upc",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "attributeValues",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ProductAttributeValueNodeConnection",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "edges",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ProductAttributeValueNodeEdge",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "node",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "ProductAttributeValueNode",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "attributeOption",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "AttributeOptionNode",
                                            "plural": false,
                                            "selections": [
                                              v16,
                                              v2
                                            ]
                                          },
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "valueMultiOption",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "AttributeOptionNodeConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "edges",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "AttributeOptionNodeEdge",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "AttributeOptionNode",
                                                    "plural": false,
                                                    "selections": [
                                                      v16,
                                                      {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "group",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "AttributeOptionGroupNode",
                                                        "plural": false,
                                                        "selections": v15
                                                      },
                                                      v2
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          v2
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "parent",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ProductNode",
                                "plural": false,
                                "selections": [
                                  v8,
                                  v7,
                                  v13,
                                  v2
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "quantity",
                            "args": null,
                            "storageKey": null
                          },
                          v9,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "priceInclTax",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "priceCurrency",
                            "args": null,
                            "storageKey": null
                          },
                          v2
                        ]
                      }
                    ]
                  }
                ]
              },
              v2,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "getTotalItems",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "items",
            "name": "categoriesShop",
            "storageKey": "categoriesShop(node:\"items\")",
            "args": [
              {
                "kind": "Literal",
                "name": "node",
                "value": "items",
                "type": "String"
              }
            ],
            "concreteType": "CategoryNode",
            "plural": true,
            "selections": v15
          },
          {
            "kind": "LinkedField",
            "alias": "collections",
            "name": "landingPage",
            "storageKey": null,
            "args": null,
            "concreteType": "RangeNode",
            "plural": true,
            "selections": [
              v2,
              v5,
              v8
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "category",
            "storageKey": "category(node:\"imprint\")",
            "args": [
              {
                "kind": "Literal",
                "name": "node",
                "value": "imprint",
                "type": "String"
              }
            ],
            "concreteType": "CategoryNode",
            "plural": false,
            "selections": v11
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "categoriesShop",
            "storageKey": "categoriesShop(node:\"Policies & services\")",
            "args": [
              {
                "kind": "Literal",
                "name": "node",
                "value": "Policies & services",
                "type": "String"
              }
            ],
            "concreteType": "CategoryNode",
            "plural": true,
            "selections": v11
          },
          v2
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '86b1c89824e458818450f0cea1956a63';
module.exports = node;
